
export const order = 3;
export const routes = {
  path: "/",
  name: "classHourStatisticsLayout",
  component: () => import("@/views/layout"),
  meta: {
    title: "学时统计",
    guard: {
      role: ["Admin"],
      permission: ["upms:classHourStatistics"],
    },
  },
  children: [
    {
      path: "classHourStatisticsPage",
      name: "classHourStatisticsPage",
      meta: {
        title: "学时统计",
        guard: {
          role: ["Admin"],
          permission: ["upms:learningInputPage"],
        },
      },
      component: () => import("@/views/classHourStatistics")
    }
  ]
};
export const perms = {};
